

<div class="row">
	<button style="margin-left:15px;" class="btn btn-info btn-purchasenewpack" (click)="openImageUpload()">Upload Image</button>
	<input type='text'
           style='color:black;padding: 0px 0px 0px 10px; margin:0px 0px 0px 10px;'
		   placeholder='Search..'
		   (keyup)='filterImages()' [(ngModel)]="searchText"/>
</div>
<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

<ngx-datatable
			   class='material striped datatable'
			   [rows]='display'
			   [columnMode]='"force"'
			   [headerHeight]='40'
			   [footerHeight]='20'
			   [scrollbarV]="true"
			   [rowHeight]="40"
			   [reorderable]="true"
			   [sorts]="[{prop: 'name', dir: 'asc'}]"
			   [messages]="{emptyMessage:'Nothing to see here'}">						

	<ngx-datatable-column prop="name" [sortable]="true" [width]="150" [minWidth]="150" >
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Image Name
			</span>
		</ng-template>
		<ng-template let-row="row" ngx-datatable-cell-template >
			{{row.name}}
		</ng-template>
	</ngx-datatable-column>  		   
		
	<ngx-datatable-column prop="url" [sortable]="true" [minWidth]="300" [width]="600"  [maxWidth]="800" >
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Public URL
			</span>
		</ng-template>
		<ng-template let-row="row" let-rowIndex="rowIndex"  ngx-datatable-cell-template >
			<a *ngIf="!copied[rowIndex + '-url']" (click)="copy(row.url, rowIndex)"  href='#' style="padding-right: 8px"> <i class="m-menu__link-icon flaticon-clipboard"></i></a>
			<a *ngIf="copied[rowIndex + '-url']" (click)="copy(row.url, rowIndex)"  href='#' style="padding-right: 8px"> <i class="m-menu__link-icon flaticon-close"></i></a>
			<a (click)="copy(row.url, rowIndex)" href='#'>{{row.url}}</a>  
		</ng-template>
	</ngx-datatable-column>

	<ngx-datatable-column name="lastModified" [minWidth]="200">
		<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
			<span (click)="sort()" >
				Last Modified
			</span>
		</ng-template>
		<ng-template let-row="row" ngx-datatable-cell-template >
			{{row.lastModified | date:'EEEE, MMMM d, y'}}
		</ng-template>
	  </ngx-datatable-column>

		<ngx-datatable-column prop="edit" [minWidth]="120" >
			<ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
				<span></span>
			</ng-template>
			<ng-template let-row="row" ngx-datatable-cell-template >
				<button type="button" (click)="delete(row.bucketName, row.path, row.name)">Delete</button>
			</ng-template>
		</ngx-datatable-column>	


</ngx-datatable>


				

							
				 
